import { translationOrganizations_da } from "./translationOrganizations.da";
import { defineDashboardTranslations } from "./translationTypes";
import { translationOrganizations_en } from "./translationOrganizations.en";
import { translationOrganizations_sv } from "./translationOrganizations.sv";

export const translationOrganizations = defineDashboardTranslations({
  da: translationOrganizations_da,
  en: translationOrganizations_en,
  sv: translationOrganizations_sv,
});
